'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischargeForm$() {
  this.aON = null;
  this.aP4 = null;
  this.aOQ = null;
  this.aOR = false;
  this.aOW = null;
  this.aOX = false;
  this.aP2 = null;
  this.aP3 = false;
  this.aOO = null;
  this.aOP = false;
  this.aP0 = null;
  this.aP1 = false;
  this.aOY = null;
  this.aOZ = false;
  this.aOS = null;
  this.aOT = false;
  this.aOU = null;
  this.aOV = false;
  $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischargeForm$ = this;
  this.aON = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischarge$();
  this.aP4 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fchimney$package$().eU($m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischarge$());
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischargeForm$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischargeForm$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischargeForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischargeForm$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischargeForm$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischargeForm$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischargeForm$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischargeForm$.prototype = $p;
$p.eR = (function() {
  return this.aON;
});
$p.eO = (function() {
  return this.aP4;
});
$p.bW = (function() {
  if ((!this.aOR)) {
    this.aOQ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aOR = true;
  }
  return this.aOQ;
});
$p.b9 = (function() {
  if ((!this.aOX)) {
    this.aOW = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1(this);
    this.aOX = true;
  }
  return this.aOW;
});
$p.b3 = (function() {
  if ((!this.aP3)) {
    this.aP2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5(this);
    this.aP3 = true;
  }
  return this.aP2;
});
$p.aG = (function() {
  if ((!this.aOP)) {
    this.aOO = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(this);
    this.aOP = true;
  }
  return this.aOO;
});
$p.az = (function() {
  if ((!this.aP1)) {
    this.aP0 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aP1 = true;
  }
  return this.aP0;
});
$p.aY = (function() {
  if ((!this.aOZ)) {
    this.aOY = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().eS(this.az());
    this.aOZ = true;
  }
  return this.aOY;
});
$p.sY = (function() {
  if ((!this.aOT)) {
    this.aOS = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Port/Airport of Discharge";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aOT = true;
  }
  return this.aOS;
});
$p.afq = (function() {
  if ((!this.aOV)) {
    this.aOU = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_components_TextKindFor$().jx;
    this.aOV = true;
  }
  return this.aOU;
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischargeForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischargeForm$, "app.data.data_point_types$package$PlaceOfDischargeForm$", ({
  Gh: 1,
  N: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischargeForm$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischargeForm$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischargeForm$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischargeForm$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischargeForm$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischargeForm$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischargeForm$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischargeForm$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischargeForm$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischargeForm$ };
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischarge$() {
  this.aOL = null;
  this.aOM = false;
  this.aOJ = null;
  this.aOK = false;
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischarge$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischarge$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischarge$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischarge$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischarge$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischarge$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischarge$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischarge$.prototype = $p;
$p.aA = (function() {
  if ((!this.aOM)) {
    this.aOL = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.aOM = true;
  }
  return this.aOL;
});
$p.afi = (function() {
  if ((!this.aOK)) {
    this.aOJ = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischargeForm$().sY();
    this.aOK = true;
  }
  return this.aOJ;
});
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__validate__T__O(this, input);
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischarge$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischarge$, "app.data.data_point_types$package$PlaceOfDischarge$", ({
  Gg: 1,
  B: 1,
  C: 1,
  J: 1,
  M: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischarge$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischarge$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischarge$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischarge$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischarge$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischarge$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischarge$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischarge$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischarge$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PlaceOfDischarge$ };
//# sourceMappingURL=app.data.data_point_types$package$-Place-Of-Discharge$.js.map
